<!-- 工单构成分布 -->
<template>
  <div class="m-panel">
    <div class="m-panel-bar">
      <div class="m-panel-bar-title">
        {{title}}
      </div>
    </div>
    <div class="m-panel-body">
      <Echart :options="option" style="height: 100%;"></Echart>
      <!-- <div style="display: flex;">
        <div id="chart" style="height: 100%;width: 65%;"></div>
        <div class="progress">
          <div class="title">
            <div>紧急</div>
            <div><i>66</i></div>
          </div>
          <a-progress strokeColor="#3BA1FF" :percent="67" :strokeWidth="15" :show-info="false" class="finish" />
          <div class="title">
            <div>重要</div>
            <div><i>44</i></div>
          </div>
          <a-progress strokeColor="#69D389" :percent="78" :strokeWidth="15" :show-info="false" class="notfinish" />
          <div class="title">
            <div>一般</div>
            <div><i>55</i></div>
          </div>
          <a-progress strokeColor="#FFC328" :percent="55" :strokeWidth="15" :show-info="false" class="timeout"/>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
  import echarts from 'echarts/lib/echarts';
  import {
    postAction
  } from '@/api/manage'
  export default {
    data() {
      return {
        title: this.$t('工单构成分布'),
        url: {
          queryTicketsTypeNum: "/jeecg-engineering/ticket/index/largeScreen/queryTicketsTypeNum",
        },
        option: {},
        intervalId: null,
        angle: 0
      }
    },
    mounted() {},
    methods: {
      init() {
        this.getData();
        this.resetData();
      },
      resetData() {
          this.option = this.$options.data.call(this).option
          if(this.intervalId !== null){
              clearInterval(this.intervalId)
              this.intervalId = null;
          }
          this.angle = this.$options.data.call(this).angle
      },
      getData(){
        postAction(this.url.queryTicketsTypeNum,{queryType:''}).then(res=>{
          if(res.success){
            var data = res.result;
            var num0 = '';
            var num1 = '';
            var num2 = '';
            data.map(d=>{
              if(d.typeName == 0){
                num0 = d.num
              }else if(d.typeName == 1){
                num1 = d.num
              }else{
                num2 = d.num
              }
            })
            this.setOption(num0,num1,num2);
            // setTimeout(()=> {
            //     this.intervalId = setInterval(()=>{
            //         this.angle = this.angle + 5
            //         this.setOption(data[0].num,data[1].num,data[2].num)
            //     },100)
            // },1000)
          }
        })
      },
      setOption(a,b,c) {
        let angle = this.angle
        let data = [{
            value: a,
            name: this.$t('换表')
          },
          {
            value: b,
            name: this.$t('工程报装')
          },
          {
            value: c,
            name: this.$t('故障报修')
          },
        ]
        let total = a+b+c;
        let color = [{
          start: '#0C2D82',
          end: '#3A7BD5'
        }, {
          start: '#B620E0',
          end: '#4634FA'
        }, {
          start: '#50E3C2',
          end: '#32C5FF'
        }]
        let color1 = [{
          start: '#fff',
          end: '#3A7BD5'
        }, {
          start: '#fff',
          end: '#4634FA'
        }, {
          start: '#fff',
          end: '#FA6400'
        }]
        let seriesData = []
        for (let i = 0; i < data.length; i++) {
          seriesData.push({
            name: data[i].name,
            value: data[i].value,
            itemStyle: {
              normal: {
                borderWidth: 5,
                color: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                      offset: 0,
                      color: color[i].start
                    },
                    {
                      offset: 1,
                      color: color[i].end
                    }
                  ]
                ),
                borderColor: new echarts.graphic.LinearGradient(
                  0, 0, 0, 1,
                  [{
                      offset: 0,
                      color: color[i].start
                    },
                    {
                      offset: 1,
                      color: color[i].end
                    }
                  ]
                ),
      
              }
            }
          })
        }
        this.option = {
          color: ['#0C2D82', '#B620E0', '#50E3C2'],
          // color: ['#FECA20', '#50E3C2', '#32C5FF', '#0091FF', '#0394FF', '#4634FA', '#0C2D82', '#B620E0', '#F7B500', '#FA6400', '#E02020'],
          tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0,11,42,0.9)',
            borderColor: '#5D6A94',
            borderWidth: 1,
            borderRadius: 8,
            textStyle: {
              color: '#CEE2FF',
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#019AF3'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          title: {
            text: `{total|${total}}{unit|${this.$t('件')}}`,
            textStyle: {
              color: '#52C4DF',
              rich: {
                total: {
                  color: '#52C4DF',
                  fontWeight: 500,
                  fontSize: 30,
                  fontFamily: 'ds-digital-bold'
      
                },
                unit: {
                  color: '#2A6BAC',
                  fontSize: 12,
                }
              }
            },
            left: 'center',
            top: 'center',
            itemGap: 0,
            subtext: this.$t('总数量'),
            subtextStyle: {
              color: '#fff',
              verticalAlign: 'middle',
              lineHeight: 12
            }
          },
          series: [{
              name: "ring5",
              type: 'custom',
              coordinateSystem: "none",
              renderItem: function(params, api) {
                return {
                  type: 'arc',
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                    startAngle: (0 + angle) * Math.PI / 180,
                    endAngle: (90 + angle) * Math.PI / 180
                  },
                  style: {
                    stroke: "#00A2F3",
                    opacity: 0.5,
                    fill: "transparent",
                    lineWidth: 2
                  },
                  silent: true
                };
              },
              data: [0]
            },
            {
              name: "ring5",
              type: 'custom',
              coordinateSystem: "none",
              renderItem: function(params, api) {
                return {
                  type: 'arc',
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                    startAngle: (120 + angle) * Math.PI / 180,
                    endAngle: (210 + angle) * Math.PI / 180
                  },
                  style: {
                    stroke: "#00A2F3",
                    opacity: 0.5,
                    fill: "transparent",
                    lineWidth: 2
                  },
                  silent: true
                };
              },
              data: [0]
            },
            {
              name: "ring5",
              type: 'custom',
              coordinateSystem: "none",
              renderItem: function(params, api) {
                return {
                  type: 'arc',
                  shape: {
                    cx: api.getWidth() / 2,
                    cy: api.getHeight() / 2,
                    r: Math.min(api.getWidth(), api.getHeight()) / 2 * 0.4,
                    startAngle: (240 + angle) * Math.PI / 180,
                    endAngle: (330 + angle) * Math.PI / 180
                  },
                  style: {
                    stroke: "#00A2F3",
                    fill: "transparent",
                    opacity: 0.5,
                    lineWidth: 2
                  },
                  silent: true
                };
              },
              data: [0]
            },
            {
              name: '',
              type: 'pie',
              roseType: 'area',
              radius: ['50%', '80%'],
              center: ['50%', '50%'],
              animationDelay: 100,
              animationDuration: 2000,
              label: {
                show: true,
                position: 'outer',
                width: 0,
                height: 0,
                lineHeight: 0,
                padding: [2, -2, 2, -2],
                borderRadius: 2,
                distanceToLabelLine: 0,
                formatter: (params) => {
                  let percent = 0
                  if (total == 0) {
                    percent = 100
                  }
                  let index = params.dataIndex
                  percent = ((params.value / total) * 100).toFixed(0);
                  return [
                    `{topnumber${index}|${params.value}}{top${index}|${this.$t('件')}}{topnumber${index}|${percent}}{top${index}|%}\n{bottom${index}|${params.name}}`,
                    `{hr${index}|}`
                  ].join('\n')
                },
                align: 'center',
                color: '#fff',
                rich: this.setRichText(color1)
              },
              labelLine: {
                // show: false,
                normal: {
                  smooth: 0.2,
                  length: 15,
                  length2: 45,
                }
              },
              data: seriesData
            }
          ]
        };
      },
      setRichText(colorList) {
        let richList = {}
        for (let i = 0; i < colorList.length; i++) {
          richList[`top${i}`] = {
            color: colorList[i].start,
            verticalAlign: 'bottom',
            padding: [5, 0, 0, 0],
            align: 'center'
          }
          richList[`topnumber${i}`] = {
            color: colorList[i].start,
            fontFamily: 'ds-digital-bold',
            verticalAlign: 'bottom',
            padding: [5, 0, 0, 0],
            fontSize: 20,
            align: 'center'
          }
          richList[`bottom${i}`] = {
            color: colorList[i].start,
            verticalAlign: 'top',
            padding: [0, 0, 5, 0],
            align: 'center'
          }
          richList[`hr${i}`] = {
            backgroundColor: colorList[i].start,
            borderRadius: 3,
            width: 3,
            height: 3,
            align: 'center',
            padding: [3, 3, 0, -12]
          }
        }
        return richList
      },
    },
  }
</script>
<style lang="less" scoped>
  .tabs {
    display: flex;
    position: absolute;
    right: 0;
  }

  .tab {
    padding: 6px 8px;
    margin: 0 0 0 0;

    cursor: pointer;
  }

  .tab-active {
    position: relative;
  }

  .tab-active::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    content: '';
    height: 2px;
    background-color: #019AF3;
    transition: all .3s;

  }

  .tab:last-child {

    margin-right: 0;
  }

  .tab-title {
    font-size: 12px;
    font-weight: normal;
    color: #7993b3;
    cursor: pointer;
  }

  .tab-active .tab-title {
    color: #cbdff7;
    position: relative;
    font-weight: 500;
  }

  .trends-box {}
  .ant-radio-button-wrapper{
    color: #fff;
    background: transparent;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled){
    color: #1890FF;
  }
  .progress{
    width: 35%;
    font-size: 12px;
    padding: 10px;
    .title{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /deep/.ant-progress-line{
      margin-bottom: 25px;
    }
    /deep/.finish .ant-progress-inner{
      background-color: #08306F;
    }
    /deep/.notfinish .ant-progress-inner{
      background-color: #20515B;
    }
    /deep/.timeout .ant-progress-inner{
      background-color: #5B5B34;
    }
  }
</style>